import { tns } from 'tiny-slider/src/tiny-slider';

/**
 * Partner logos carousel (Logos block, Slider display).
 *
 * Each logo is its own slide (grav-blocks/logos/block.php), and the slider
 * shows whole logos only: two at a time on phones, three from 768px up
 * (TPN-145: the old six-logo slides were wider than the slider, so logos
 * were cut off at the edges). It moves a page at a time and builds its own
 * page dots, so the number of dots always matches the number of pages at
 * the current width. The nav argument is kept for callers but unused.
 */
class LogosSlider {
	constructor(el, nav) {
		this.el = el;
		this.nav = nav;

		const logosSlider = tns({
			container: this.el,
			autoplay: true,
			autoplayButtonOutput: false,
			mouseDrag: true,
			preventScrollOnTouch: 'auto',
			swipeAngle: false,
			speed: 400,
			controls: false,
			gutter: 20,
			items: 2,
			responsive: {
				768: { items: 3 },
			},
			slideBy: 'page',
			nav: true,
			navPosition: 'bottom',
		});

		return logosSlider;
	}
}

export default LogosSlider;
